import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import firebase from 'firebase'
import styled from 'styled-components'
import moment from 'moment'
import { deleteMap, saveMap } from '../../store/actions/mapActions'

const FormContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 350px));
  grid-gap: 20px;
  padding: 20px;
  font-family: 'Montserrat', sans-serif;
  min-height: 100vh;
  background: #0063c0;
  color: #0063c0;
  margin-left: 230px;
  @media only screen and (max-width: 700px) {
    margin-left: 0;
  }
`
const FormCard = styled.div`
  background: #FFF;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11),
              0 5px 15px 0 rgba(0,0,0,0.08);
`
const DescriptionText = styled.h3`
  color: #30332E;
  font-size: 1em;
  font-weight: normal;
`
const TopicText = styled.h3`
  color: #30332E;
  font-size: .9em;
  font-weight: normal;
  margin: 5px 0;
`
const AuthorandDateText = styled.h3`
  color: #30332E;
  font-size: .9em;
  font-weight: normal;
  margin: 5px 0;
`
const ResourceLink = styled.a`
  color: #0063c0;
  font-size: 1em;
  font-weight: bold;
  text-decoration: none;
  :hover {
    color: #DF0E62;
  }
`


class MapDetails extends Component {
  
  linkFunction = () => {
    let linkArray = []
    for (let i = 1; i < this.props.map.numOfLinks+1; i++) {
      let linkTitle = this.props.map[`linkTitle${i}`]
      let link = this.props.map[`link${i}`]
      let linkDescription = this.props.map[`linkDescription${i}`]
      linkArray.push(
        <div key={Date.now()}>
          <ResourceLink href={`${link}`} target="_blank">{linkTitle}</ResourceLink>
          <DescriptionText>{linkDescription}</DescriptionText>
        </div>
      )
    }
    return linkArray
  }

  deletePost = () => {
    this.props.deleteMap(this.props.match.params.id);
    this.props.history.push('/')
  }

  // saveMap = () => {
  //   this.props.saveMap(this.props.match.params.id, firebase.auth().currentUser.uid);
  // }

  render() {
    const {map} = this.props
    const currentUser = firebase.auth().currentUser
    if (map) {
      return (
        <FormContainer>
          <FormCard>
            <h2>{map.title}</h2>
            <DescriptionText>{map.content}</DescriptionText>
            <TopicText>Topic: {map.topic}</TopicText>
            <AuthorandDateText> by {map.authorDisplayName} on {moment(map.createdAt.toDate()).calendar()}</AuthorandDateText>
            {currentUser !== null ? 
              (currentUser.uid === map.authorId ? 
              <button onClick={this.deletePost}>Delete Post</button> : 
              <div></div>) : 
            <div></div>}
            {/* {currentUser !== null ? 
               <button onClick={this.saveMap}>Save Post</button>: 
            <div></div>} */}
          </FormCard>
          <FormCard>
            <h2>Resources</h2>
            {this.linkFunction()}
          </FormCard>
        </FormContainer>
      )
    } else {
      return (<div></div>)
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const maps = state.firestore.data.maps;
  const map = maps ? maps[id] : null
  return {
    map: map,
    auth: state.firebase.auth
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteMap: (map) => dispatch(deleteMap(map)),
    saveMap: (map, userID) => dispatch(saveMap(map, userID))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([{
    collection: 'maps'
  }])
)(MapDetails)



// WEBPACK FOOTER //
// ./src/components/maps/MapDetails.js